import styled from '@emotion/styled'

import {
  WORKFLOW_CONDITION_IS_TODAY,
  WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY,
  WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY,
  WORKFLOW_CONDITION_PLUS_X_HOURS_IS_NOW,
  WORKFLOW_FIELD_TYPE_DATETIME
} from 'Constants/'
import {
  Flex,
  FlexItem,
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputNumber,
  RadioButton,
  Select
} from 'mailup-web-components'

import {
  eventFieldTypes,
  eventFieldTypesBirthday,
  workflowCommonDataState,
  workflowDetails
} from 'Pages/Workflow/recoil/state/data'

import { OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE } from 'Constants/index'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'

const StyledInlineLabel = styled.label`
  font-weight: 400;
  cursor: pointer;
`

const StartTypeEvent = () => {
  const intl = useIntl()

  const { IdField, FieldType, IdFieldFilter, FieldValue } =
    useRecoilValue(step2State)
  const { dynamicFields } = useRecoilValue(workflowCommonDataState)
  const { Type: workflowDetailsType } = useRecoilValue(workflowDetails)

  const setWorkflowDetailsState = useSetRecoilState(step2State)

  // dirty fields
  const [idFieldDirty, setIdFieldDirty] = useState(false)
  const [fieldTypeDirty, setFieldTypeDirty] = useState(false)

  // tmp fields
  const [hoursAfter, setHoursAfter] = useState(
    FieldType === WORKFLOW_FIELD_TYPE_DATETIME ? parseInt(FieldValue) : 1
  )

  const [daysBefore, setDaysBefore] = useState(
    FieldType !== WORKFLOW_FIELD_TYPE_DATETIME &&
      IdFieldFilter === WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY
      ? parseInt(FieldValue)
      : 1
  )

  const [daysAfter, setDaysAfter] = useState(
    FieldType !== WORKFLOW_FIELD_TYPE_DATETIME &&
      IdFieldFilter === WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY
      ? parseInt(FieldValue)
      : 1
  )

  const fieldTypeOptions = useMemo(() => {
    return eventFieldTypes.map(({ label, value }) => ({
      value,
      label: intl.formatMessage({ id: label })
    }))
  }, [])

  const fieldTypeOptionsBirthday = useMemo(() => {
    return eventFieldTypesBirthday.map(({ label, value }) => ({
      value,
      label: intl.formatMessage({ id: label })
    }))
  }, [])

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  const wrongFormatFeedback = (maxDays = 999) =>
    intl.formatMessage(
      {
        id: 'Load.AutomationWorkflow.LastDayValidation'
      },
      {
        XGIORNI: maxDays
      }
    )

  const handleChangeIdField = (value) => {
    setIdFieldDirty(true)
    setWorkflowDetailsState((prev) => ({ ...prev, IdField: value }))
  }

  const handleChangeFieldType = (value) => {
    setFieldTypeDirty(true)
    setWorkflowDetailsState((prev) => ({
      ...prev,
      FieldType: value,
      IdFieldFilter:
        value === WORKFLOW_FIELD_TYPE_DATETIME
          ? WORKFLOW_CONDITION_PLUS_X_HOURS_IS_NOW
          : prev.FieldType === WORKFLOW_FIELD_TYPE_DATETIME
            ? WORKFLOW_CONDITION_IS_TODAY
            : prev.IdFieldFilter,
      FieldValue:
        value === WORKFLOW_FIELD_TYPE_DATETIME && prev.FieldType !== value
          ? 1
          : prev.FieldValue
    }))

    // reset to default value
    /*
    if (value !== WORKFLOW_FIELD_TYPE_DATETIME) {
      setDaysBefore(1)
      setDaysAfter(1)
    } else {
      setHoursAfter(1)
    }
    */

    /*

    if (
      value !== FieldType &&
      (value === WORKFLOW_FIELD_TYPE_DATETIME ||
        FieldType === WORKFLOW_FIELD_TYPE_DATETIME)
    ) {
      setFieldTypeDirty(true)
      setWorkflowDetailsState((prev) => ({
        ...prev,
        FieldType: value,
        IdFieldFilter:
          value !== WORKFLOW_FIELD_TYPE_DATETIME // reset to default value
            ? WORKFLOW_CONDITION_IS_TODAY
            : prev.IdFieldFilter,
        FieldValue: '1'
      }))

      // reset to default value
      if (value !== WORKFLOW_FIELD_TYPE_DATETIME) {
        setDaysBefore(1)
        setDaysAfter(1)
      } else {
        setHoursAfter(1)
      }
    }
    */
  }

  const handleHoursAfterChange = (value) => {
    setHoursAfter(value)
    setWorkflowDetailsState((prev) => ({ ...prev, FieldValue: `${value}` }))
  }

  const handleDaysBeforeChange = (value) => {
    setDaysBefore(value)
    setWorkflowDetailsState((prev) => ({ ...prev, FieldValue: `${value}` }))
  }

  const handleDaysAfterChange = (value) => {
    setDaysAfter(value)
    setWorkflowDetailsState((prev) => ({ ...prev, FieldValue: `${value}` }))
  }

  const handleConditionTodayChange = ({ target: { checked } }) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      IdFieldFilter: WORKFLOW_CONDITION_IS_TODAY,
      FieldValue: ''
    }))
    setDaysBefore(1)
    setDaysAfter(1)
  }

  const handleConditionDaysBeforeChange = ({ target: { checked } }) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      IdFieldFilter: WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY,
      FieldValue: `${daysBefore}`
    }))
  }

  const handleConditionDaysAfterChange = ({ target: { checked } }) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      IdFieldFilter: WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY,
      FieldValue: `${daysAfter}`
    }))
  }

  const hoursAfterIsValid =
    hoursAfter !== null && hoursAfter >= 0 && hoursAfter <= 9999

  const daysBeforeIsValid =
    daysBefore !== null && daysBefore >= 0 && daysBefore <= 999

  const daysAfterIsValid =
    daysAfter !== null && daysAfter >= 0 && daysAfter <= 999

  return (
    <>
      <FormElement
        label={intl.formatMessage({
          id: 'Load.AutomationWorkflow.CustomFieldLabel'
        })}
        required
        feedback={idFieldDirty && !IdField ? requiredFeedback : undefined}
        variant={idFieldDirty && !IdField ? 'danger' : undefined}
      >
        <Select
          value={IdField}
          options={dynamicFields}
          placeholder={intl.formatMessage({
            id: 'Load.AutomationWorkflow.SelectFieldPlaceholder'
          })}
          onChange={handleChangeIdField}
          error={idFieldDirty && !IdField}
        />
      </FormElement>
      <FormElement
        label={intl.formatMessage({
          id: 'Load.AutomationWorkflow.DateFormatLabel'
        })}
        labelHelp={
          workflowDetailsType === OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE
            ? intl.formatMessage({
                id: 'Load.AutomationWorkflow.DateFormatTooltip'
              })
            : undefined
        }
        required
        feedback={fieldTypeDirty && !FieldType ? requiredFeedback : undefined}
        variant={fieldTypeDirty && !FieldType ? 'danger' : undefined}
      >
        <Select
          value={FieldType}
          options={
            workflowDetailsType === OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE
              ? fieldTypeOptionsBirthday
              : fieldTypeOptions
          }
          placeholder={intl.formatMessage({
            id: 'Load.AutomationWorkflow.SelectTypeConditionPlaceholder'
          })}
          onChange={handleChangeFieldType}
          error={fieldTypeDirty && !FieldType}
        />
      </FormElement>

      <FormElement
        label={intl.formatMessage({
          id: 'Load.AutomationWorkflow.EventTimeTile'
        })}
        required
      >
        {FieldType === WORKFLOW_FIELD_TYPE_DATETIME ? (
          <Flex margin='24px 0'>
            <FormElement
              feedback={
                !hoursAfterIsValid ? wrongFormatFeedback(9999) : undefined
              }
              feedbackVariant={!hoursAfterIsValid ? 'danger' : undefined}
            >
              <Flex alignItems='flex-start'>
                <Flex
                  display='block'
                  width='85px'
                  flexGrow='0'
                  margin='0 16px 0 0'
                >
                  <InputNumber
                    value={hoursAfter}
                    onChange={handleHoursAfterChange}
                    min={0}
                    max={9999}
                    step={1}
                    maxLength={4}
                    variant={
                      !hoursAfterIsValid ? INPUT_TEXT_VARIANT_DANGER : undefined
                    }
                  />
                </Flex>
                <FlexItem margin='8px 0 0 0'>
                  <StyledInlineLabel>
                    {intl.formatMessage({
                      id: 'Load.AutomationWorkflow.EventTimeHoursAfter'
                    })}
                  </StyledInlineLabel>
                </FlexItem>
              </Flex>
            </FormElement>
          </Flex>
        ) : (
          <Flex margin='24px 0' rowGap='16px' flexDirection='column'>
            <Flex justifyContent='flex-start' alignItems='center'>
              <RadioButton
                id='eventConditionToday'
                value={WORKFLOW_CONDITION_IS_TODAY}
                checked={IdFieldFilter === WORKFLOW_CONDITION_IS_TODAY}
                onChange={handleConditionTodayChange}
              />
              <StyledInlineLabel htmlFor='eventConditionToday'>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.EventTimeToday'
                })}
              </StyledInlineLabel>
            </Flex>

            <Flex justifyContent='flex-start' alignItems='flex-start'>
              <FlexItem margin='8px 0 0 0'>
                <RadioButton
                  id='eventConditionBefore'
                  value={WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY}
                  checked={
                    IdFieldFilter === WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY
                  }
                  onChange={handleConditionDaysBeforeChange}
                />
              </FlexItem>
              <FormElement
                feedback={
                  !daysBeforeIsValid ? wrongFormatFeedback(999) : undefined
                }
                feedbackVariant={!daysBeforeIsValid ? 'danger' : undefined}
              >
                <Flex alignItems='flex-start'>
                  <Flex
                    display='block'
                    width='75px'
                    flexGrow='0'
                    margin='0 16px 0 0'
                  >
                    <InputNumber
                      value={daysBefore}
                      onChange={handleDaysBeforeChange}
                      disabled={
                        IdFieldFilter !==
                        WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY
                      }
                      min={0}
                      max={999}
                      step={1}
                      maxLength={3}
                      variant={
                        !daysBeforeIsValid
                          ? INPUT_TEXT_VARIANT_DANGER
                          : undefined
                      }
                    />
                  </Flex>
                  <FlexItem margin='8px 0 0 0'>
                    <StyledInlineLabel htmlFor='eventConditionBefore'>
                      {intl.formatMessage({
                        id: 'Load.AutomationWorkflow.EventTimeDayBefore'
                      })}
                    </StyledInlineLabel>
                  </FlexItem>
                </Flex>
              </FormElement>
            </Flex>

            <Flex justifyContent='flex-start' alignItems='flex-start'>
              <FlexItem margin='8px 0 0 0'>
                <RadioButton
                  id='eventConditionAfter'
                  value={WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY}
                  checked={
                    IdFieldFilter === WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY
                  }
                  onChange={handleConditionDaysAfterChange}
                />
              </FlexItem>
              <FormElement
                feedback={
                  !daysAfterIsValid ? wrongFormatFeedback(999) : undefined
                }
                feedbackVariant={!daysAfterIsValid ? 'danger' : undefined}
              >
                <Flex alignItems='flex-start'>
                  <Flex
                    display='block'
                    width='75px'
                    flexGrow='0'
                    margin='0 16px 0 0'
                  >
                    <InputNumber
                      value={daysAfter}
                      onChange={handleDaysAfterChange}
                      disabled={
                        IdFieldFilter !==
                        WORKFLOW_CONDITION_PLUS_X_DAYS_IS_TODAY
                      }
                      min={0}
                      max={999}
                      step={1}
                      maxLength={3}
                      variant={
                        !daysAfterIsValid
                          ? INPUT_TEXT_VARIANT_DANGER
                          : undefined
                      }
                    />
                  </Flex>
                  <FlexItem margin='8px 0 0 0'>
                    <StyledInlineLabel htmlFor='eventConditionAfter'>
                      {intl.formatMessage({
                        id: 'Load.AutomationWorkflow.EventTimeDayAfter'
                      })}
                    </StyledInlineLabel>
                  </FlexItem>
                </Flex>
              </FormElement>
            </Flex>
          </Flex>
        )}
      </FormElement>
    </>
  )
}

export default StartTypeEvent
